// extracted by mini-css-extract-plugin
export default {"invitation-code-checkbox":"DescriptionForm_invitation-code-checkbox__KeAUa"};